import { inject, Injectable } from '@angular/core';
import { Observable, of, switchMap, throwError } from 'rxjs';
import { CompanySupplierSettingsApi } from '../api/company-supplier-settings.api';
import { SupplierSettingsApiStatusResponseDto } from '../api/dtos/company-supplier-settings.dto';
import { SupplierSettingsForm } from '../models/company-form.model';

const API_SUCCESS_STATUS = 'success';

@Injectable({ providedIn: 'root' })
export class CompanySupplierSettingsService {
  private readonly _supplierSettingsApi = inject(CompanySupplierSettingsApi);

  public supplierSettings(companyId: number): Observable<SupplierSettingsForm> {
    return this._supplierSettingsApi.supplierSettings(companyId);
  }

  public updateSupplierSettings(
    companyId: number,
    form: SupplierSettingsForm,
  ): Observable<string> {
    return this._supplierSettingsApi
      .updateSupplierSettings(companyId, form)
      .pipe(switchMap((response) => this._validate(response)));
  }

  public enableSegmentation(companyId: number): Observable<string> {
    return this._supplierSettingsApi
      .setSegmentation(companyId, true)
      .pipe(switchMap((response) => this._validate(response)));
  }

  public disableSegmentation(companyId: number): Observable<string> {
    return this._supplierSettingsApi
      .setSegmentation(companyId, false)
      .pipe(switchMap((response) => this._validate(response)));
  }

  private _validate(
    response: SupplierSettingsApiStatusResponseDto,
  ): Observable<string> {
    if (response.apiStatus !== API_SUCCESS_STATUS) {
      return throwError(
        () => new Error(response.msg || 'Failed to update supplier settings.'),
      );
    }
    return of(response.msg);
  }
}
